export default "__VITE_ASSET__CrhxyQtC__"